import DashboardLayout from "@/src/components/layout/DashboardLayout";
import { headerApiService } from "@/src/lib/api-services/headerApiServices";
import React, { useCallback, useEffect, useState } from "react";
import { useRouter } from "next/router";
import FindTestCard from "@/src/modules/find-a-test/findTestCard";
// import ConfirmDialog from "@/src/components/confirm-dialog";
import ConfirmDialog from "@/src/lib/ui/confirmDialog";
import IconCode from "@/src/lib/iconCode";
import Iconify from "@/src/components/iconify";
import FilterSearchModal from "@/src/modules/find-a-test/filterSearchModal";
import useBreakpoint from "@/src/lib/util/custom-hooks/useBreakPoint";
import Link from "next/link";
import CustomButton from "@/src/lib/ui/Button";

FindATest.getLayout = (page) => <DashboardLayout>{page}</DashboardLayout>;

function FindATest({ query, searchTestData, seaoData }) {
    const router = useRouter();
    const isMobile = useBreakpoint("sm");
    const [searchFilter, setSearchFilter] = useState(null);
    // const [searchResults, setSearchResults] = useState(searchTestData); // Use SSR data
    // const [loadMoreLoading, setLoadMoreLoading] = useState(false);
    const [openPopup, setOpenPopup] = useState(false);

    useEffect(() => {
        const { search, category, specializations, page } = query;
        const initialFilter = {
            limit: 35,
            page: Number(page) || 1,
            filter: {
                search: search || "",
                category: category || "",
                specializations: specializations
                    ? JSON.parse(specializations)
                    : [],
            },
        };

        if (page < 0) {
            return;
        }

        setSearchFilter((prev) => {
            if (JSON.stringify(prev) !== JSON.stringify(initialFilter)) {
                return initialFilter;
            }
            return prev;
        });
    }, []);

    // // Fetch data on filter change (client-side for interactions)
    // useEffect(() => {
    //     if (searchFilter !== null) {
    //         const updatedSearchFilter = getUpdatedFilterParams(
    //             searchFilter,
    //             true
    //         );
    //         //   fetchData(updatedSearchFilter);
    //     }
    // }, [searchFilter]);

    const handleChangeSpecialization = (val, checked) => {
        const updatedSpecializations = checked
            ? [...(searchFilter?.filter?.specializations || []), val]
            : searchFilter?.filter?.specializations.filter(
                  (item) => item !== val
              );

        setSearchFilter((prev) => ({
            ...prev,
            filter: {
                ...prev.filter,
                specializations: updatedSpecializations,
            },
        }));
    };

    const handleChangeFacilities = (val) => {
        setSearchFilter((prev) => ({
            ...prev,
            filter: {
                ...prev.filter,
                category: val,
            },
        }));
    };
    const getUpdatedFilterParams = (filterParams, flag = false) => {
        const updatedSearchFilter = JSON.parse(JSON.stringify(filterParams));

        const { search, category, specializations, allowHc } =
            updatedSearchFilter?.filter;

        const newFilter = {};
        if (search) {
            newFilter.search = search;
        }

        if (category) {
            newFilter.category = Number(category);
        }

        if (specializations && specializations?.length > 0) {
            newFilter.specializations = flag
                ? specializations
                : JSON.stringify(specializations);
        }

        newFilter.allowHc = allowHc;

        updatedSearchFilter.filter = newFilter;

        return updatedSearchFilter;
    };

    const handleApplyFilters = () => {
        const updatedFilter = getUpdatedFilterParams(searchFilter);
        router.push({
            pathname: "/find-a-test",
            query: {
                ...query,
                ...updatedFilter.filter,
            },
        });
        onClosePopupHandler();
    };

    // Clear all filters
    const clearAllFilters = () => {
        setSearchFilter({
            page: 1,
            filter: {
                search: "",
                category: "",
                specializations: [],
            },
        });
        router.push("/find-a-test");
    };

    const onClosePopupHandler = useCallback(() => {
        setOpenPopup(false);
    }, []);

    const onOpenPopupHandler = useCallback(() => {
        setOpenPopup(true);
    }, []);

    return (
        <>
            <div className="bg-gray-100 md:py-5 py-3 min-h-screen">
                {/* Mobile Top Filters & Sort */}
                {isMobile && (
                    <>
                        <div className="flex flex-row items-center justify-around py-3 w-full bg-white border-b border-solid border-gray-200 border-t shadow-sm">
                            <p
                                onClick={onOpenPopupHandler}
                                className="md:text-lg text-black md:font-medium cursor-pointer"
                            >
                                Filters
                            </p>
                            <p className="md:text-lg text-black md:font-medium">
                                Sort by
                            </p>
                        </div>
                    </>
                )}

                <div className="container mx-auto p-4">
                    <div className="grid grid-cols-12 gap-4">
                        {/* Desktop Filters */}
                        {!isMobile && (
                            <div className="col-span-12 md:col-span-3">
                                <FilterSearchModal
                                    router={query}
                                    handleChangeFacilities={(val) => {
                                        setSearchFilter((prev) => ({
                                            ...prev,
                                            filter: {
                                                ...prev?.filter,
                                                category: val,
                                            },
                                        }));
                                        // For desktop, apply filter changes immediately using router
                                        router.push({
                                            pathname: "/find-a-test",
                                            query: {
                                                ...query,
                                                category: val,
                                            },
                                        });
                                    }}
                                    searchFilter={searchFilter?.filter}
                                    handleChangeSpecialization={(
                                        val,
                                        checked
                                    ) => {
                                        // For desktop, apply filter changes immediately using router
                                        const updatedSpecializations = checked
                                            ? [
                                                  ...(searchFilter?.filter
                                                      ?.specializations || []),
                                                  val,
                                              ]
                                            : searchFilter?.filter?.specializations.filter(
                                                  (item) => item !== val
                                              );

                                        setSearchFilter((prev) => ({
                                            ...prev,
                                            filter: {
                                                ...prev?.filter,
                                                specializations:
                                                    updatedSpecializations,
                                            },
                                        }));

                                        router.push({
                                            pathname: "/find-a-test",
                                            query: {
                                                ...query,
                                                specializations: JSON.stringify(
                                                    updatedSpecializations
                                                ),
                                            },
                                        });
                                    }}
                                    handleApplyFilters={() => {}}
                                    isMobile={isMobile}
                                    clearAllFilters={clearAllFilters}
                                />
                            </div>
                        )}

                        <div className="col-span-12 md:col-span-9 flex flex-col">
                            <div className="flex justify-between items-center">
                                <h1 className="text-xl font-medium text-black">
                                    Search Results
                                </h1>

                                <CustomButton
                                    variant="text"
                                    onClick={clearAllFilters}
                                    className="text-primary"
                                >
                                    Clear Filters
                                </CustomButton>
                            </div>

                            {searchFilter?.search && (
                                <div className="border-t border-solid border-primary py-2 flex flex-row items-center justify-between">
                                    <h6 className="text-base text-black font-medium">
                                        Searched results for{" "}
                                        <span className="text-primary">
                                            {searchFilter?.search}
                                        </span>
                                    </h6>
                                </div>
                            )}

                            {/* Scrollable container for infinite scrolling */}
                            <div
                                style={{
                                    height: isMobile
                                        ? "calc(80vh)"
                                        : "calc(100vh - 200px)",
                                    overflowY: "auto",
                                }}
                                // onScroll={handleScroll}
                            >
                                {searchTestData?.products?.length === 0 ? (
                                    <p className="text-center py-10 text-black">
                                        No results found.
                                    </p>
                                ) : (
                                    <>
                                        {searchTestData?.products?.map(
                                            (item, index) => (
                                                <FindTestCard
                                                    key={index}
                                                    item={item}
                                                />
                                            )
                                        )}
                                    </>
                                )}
                            </div>

                            <div className="flex justify-between items-center">
                                {query?.page && query?.page > 1 ? (
                                    <Link
                                        rel="prev"
                                        // className="bg-primary text-white font-bold py-2 px-4 rounded-md"
                                        className="flex items-center text-primary font-medium py-2 "
                                        href={{
                                            pathname: "/find-a-test",
                                            query: {
                                                ...searchFilter?.filter,
                                                page: query?.page
                                                    ? Number(query.page) - 1
                                                    : 1,
                                            },
                                        }}
                                    >
                                        <Iconify
                                            icon={IconCode.backArrow}
                                            className="mr-2"
                                        />
                                        Back
                                    </Link>
                                ) : (
                                    <span className="invisible bg-primary text-white font-bold py-2 px-4 rounded-md">
                                        Back
                                    </span>
                                )}

                                {searchTestData?.pageinfo?.hasNextPage ? (
                                    <Link
                                        rel="next"
                                        // className="bg-primary text-white font-bold py-2 px-4 rounded-md"
                                        className="flex items-center text-primary font-medium py-2 "
                                        href={{
                                            pathname: "/find-a-test",
                                            query: {
                                                ...searchFilter?.filter,
                                                page: query?.page
                                                    ? Number(query.page) + 1
                                                    : 2,
                                            },
                                        }}
                                    >
                                        Next
                                        <Iconify
                                            icon={IconCode.forwardArrow}
                                            className="ml-2"
                                        />
                                    </Link>
                                ) : (
                                    <span className="invisible bg-primary text-white font-bold py-2 px-4 rounded-md">
                                        Next
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile Filters Popup */}
            <ConfirmDialog
                open={openPopup}
                title={
                    <div className="flex flex-row items-center justify-between">
                        <h4 className="text-2xl font-bold">Filters</h4>
                        <Iconify
                            icon={IconCode.close}
                            width={30}
                            className="text-primary cursor-pointer"
                            onClick={onClosePopupHandler}
                        />
                    </div>
                }
                content={
                    <FilterSearchModal
                        handleChangeFacilities={handleChangeFacilities}
                        searchFilter={searchFilter?.filter}
                        handleChangeSpecialization={handleChangeSpecialization}
                        handleApplyFilters={handleApplyFilters}
                        isMobile={isMobile}
                        clearAllFilters={clearAllFilters}
                        router={query}
                    />
                }
                maxWidth="xs"
                isCancel={true}
                onClose={onClosePopupHandler}
                //  slots={{ transition: Transition }}
                fullScreen={isMobile}
                spacing={0}
            />
        </>
    );
}

export default FindATest;

export const getServerSideProps = async ({ query }) => {
    const { search, category, specializations, page, allowHc } = query;

    // Define initial search filters
    const searchFilter = {
        limit: 35,
        page: Number(page) || 1,
        filter: {
            search: search || "",
            category: category || 0,
            specializations: specializations
                ? typeof specializations === "string"
                    ? JSON.parse(specializations)
                    : specializations
                : [],
            allowHc: allowHc || 0,
        },
    };

    const defaultProps = {
        data: {
            seoTitle:
                "Find Tests | Info & Test Cost | House Of Diagnostics | HOD",
            seoDescription:
                "Find Test Price for MRI CT Scan Path Lab Xray Ultrasound test at HOD Diagnostic Centres near you. Search and find test cost, preparation and info",
            routerPath: "find-a-test",
        },
        searchTestData: {
            products: [],
            pageinfo: {},
        },
    };

    if (page < 0) {
        return {
            props: {
                ...defaultProps,
                query,
            },
        };
    }

    try {
        // Fetch data on the server
        const response = await headerApiService.getSearchTest(searchFilter);

        return {
            props: {
                searchTestData: response?.data || null,
                query,
                data: defaultProps.data,
            },
        };
    } catch (error) {
        return {
            props: {
                ...defaultProps,
                query,
            },
        };
    }
};

// export async function getStaticProps() {
//     return {
//         props: {
//             data: {
//                 seoTitle:
//                     "Find Tests | Info & Test Cost | House Of Diagnostics | HOD",
//                 seoDescription:
//                     "Find Test Price for MRI CT Scan Path Lab Xray Ultrasound test at HOD Diagnostic Centres near you. Search and find test cost, preparation and info",
//                 routerPath: "find-a-test",
//             },
//         },
//     };
// }
